// extracted by mini-css-extract-plugin
module.exports = {"sorting_button":"sorting-button-light_sorting_button__HFiDq","active":"sorting-button-light_active__w8m7F"};